import Vue from 'vue';
import { mask } from 'vue-the-mask';
import VuetifyConfirm from 'vuetify-confirm';
import App from './App.vue';
import http from './http';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/element';
import dayjs from './plugins/dayjs';
import './scss/style.scss';
import eventBus from './utils/eventBus';
import './validation/validation';

Vue.config.productionTip = false;
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$http = http;
Vue.prototype.$dayjs = dayjs;
Vue.directive('mask', mask);
Vue.use(VuetifyConfirm, { vuetify });

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  beforeCreate() {
    this.$store.dispatch('initialiseStore');
  },
}).$mount('#app');
